import Navi from "./Navi";

export default Navi;
